// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { Support } from '../../types/Model';
import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface SupportPageState {
  list: Support[];
  isLoading: boolean;
  isListFetching: boolean;
  error?: Error;
}

const {
  getSupportListActions,
} = actionCreatorsList;

export const initialState: SupportPageState = {
  list: [],
  isLoading: true,
  isListFetching: true,
};

const supportListReducer = (state = initialState, action: RootAction): SupportPageState => {
  switch (action.type) {
    case getType(getSupportListActions.request): {
      return {
        ...state,
        isLoading: true,
        error: undefined
      };
    }
    case getType(getSupportListActions.success): {
      const { list } = action.payload
      return {
        ...state,
        isLoading: false,
        list
      };
    }
    case getType(getSupportListActions.failure): {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    default: {
      return state;
    }
  }
}

export { supportListReducer as default };
